import { useRef } from 'react';

import cn from 'classnames';
import { useClickOutside } from 'hooks/click-outside';
import { useClipboard } from 'hooks/clipboard';
import { useToast } from 'hooks/toast';

import styles from './LinkShare.module.scss';

export const LinkShare = ({ open, link, title, buttonText = 'Copy', onClose = () => {} }) => {
  const shareRef = useRef(null);
  const linkRef = useRef(null);

  const showToast = useToast();

  useClickOutside(shareRef, onClose);
  const copyToClipboard = useClipboard(linkRef);
  const handleCopy = () => {
    copyToClipboard();
    showToast('Copied', 'Link copied to clipboard', 'info');
  };
  return (
    <div ref={shareRef} className={cn(styles.root, 'u-border', { [styles.disabled]: !open })}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        <a className={styles.copy} onClick={handleCopy}>
          {buttonText}
        </a>
      </div>
      <input ref={linkRef} value={link} readOnly data-testid="share-link-input" />
    </div>
  );
};

export default LinkShare;
